import { CheckCircle2, Link2, Phone, Plus, Reply, X } from "lucide-react";
import { TIPOS_BOTAO } from "./modelos";

const ICONES = { link: Link2, ligar: Phone, resposta: Reply };
const DICAS = {
  link: "abre o cardápio pelo link rastreável da campanha",
  ligar: "liga pro telefone da loja",
  resposta: "o cliente toca e a resposta chega pra CLEO",
};

/**
 * Botões da mensagem própria: link do cardápio (rastreável), ligar pra loja e
 * até 3 respostas rápidas. "Parar promoções" vai sempre, por último — é o
 * descadastro exigido em marketing.
 */
export default function BotoesMensagem({ botoes, setBotoes, telefoneLoja }) {
  const qtd = (tipo) => botoes.filter((b) => b.tipo === tipo).length;
  const mudar = (i, parcial) => setBotoes(botoes.map((b, j) => (j === i ? { ...b, ...parcial } : b)));
  const adicionar = (tipo) => setBotoes([...botoes, {
    tipo, texto: TIPOS_BOTAO[tipo].padrao, ...(tipo === "ligar" ? { telefone: telefoneLoja || "" } : {}),
  }]);

  return (
    <div className="space-y-2">
      <p className="text-sm font-semibold">Botões</p>
      {botoes.map((b, i) => {
        const Icone = ICONES[b.tipo];
        return (
          <div key={i} className="rounded-lg border p-3 space-y-2">
            <div className="flex items-center gap-2">
              <Icone className="h-4 w-4 shrink-0 text-[#25d366]" />
              <span className="text-sm font-medium">{TIPOS_BOTAO[b.tipo].rotulo}</span>
              <span className="flex-1 truncate text-xs text-muted-foreground">— {DICAS[b.tipo]}</span>
              <button type="button" onClick={() => setBotoes(botoes.filter((_, j) => j !== i))}
                className="rounded p-1 text-muted-foreground hover:bg-muted hover:text-foreground" aria-label="Tirar botão">
                <X className="h-4 w-4" />
              </button>
            </div>
            <div className="flex flex-wrap gap-2">
              <input value={b.texto} onChange={(e) => mudar(i, { texto: e.target.value })} maxLength={25}
                placeholder="Texto do botão" className="min-w-[160px] flex-1 rounded-lg border bg-background px-3 py-1.5 text-sm" />
              {b.tipo === "ligar" && (
                <input value={b.telefone || ""} onChange={(e) => mudar(i, { telefone: e.target.value })} inputMode="tel"
                  placeholder="(34) 99999-9999" className="w-44 rounded-lg border bg-background px-3 py-1.5 text-sm" />
              )}
            </div>
          </div>
        );
      })}
      <div className="flex flex-wrap gap-2">
        {Object.entries(TIPOS_BOTAO).map(([tipo, t]) => (
          qtd(tipo) < t.max && (
            <button key={tipo} type="button" onClick={() => adicionar(tipo)}
              className="inline-flex items-center gap-1.5 rounded-full border border-dashed px-3 py-1.5 text-xs font-semibold hover:bg-muted">
              <Plus className="h-3.5 w-3.5" /> {t.rotulo}
            </button>
          )
        ))}
      </div>
      <div className="flex items-center gap-3 rounded-lg border bg-muted/40 p-3 text-sm">
        <CheckCircle2 className="h-4 w-4 text-[#25d366]" />
        <span className="flex-1"><b>Parar promoções</b> — vai sempre: quem tocar deixa de receber</span>
      </div>
    </div>
  );
}
